/**
 * AUTO-GENERATED by scripts/sync-shopify-plans-catalog.cjs
 * Source: scripts/shopify-plans-catalog.source.json
 * Do not edit by hand.
 */
export const SHOPIFY_FREE_MAX_VIDEO_DURATION_SEC = 300;
export const SHOPIFY_PROFESSIONAL_MAX_VIDEO_DURATION_SEC = 900;
export const SHOPIFY_STUDIO_MAX_VIDEO_DURATION_SEC = 900;

export const LEGACY_SHOPIFY_PLAN_IDS = {
  "shopify_starter": "shopify_professional",
  "shopify_growth": "shopify_studio",
  "shopify_unlimited": "shopify_agency"
};

export const SHOPIFY_PLANS = [
  {
    "id": "shopify_free",
    "title": "Free",
    "subtitle": "Try Volugraph on a few products",
    "priceUsd": 0,
    "priceSuffix": "",
    "monthlyCaptureLimit": 3,
    "lifetimeCaptureLimit": true,
    "overageEnabled": false,
    "features": [
      "3 captures included (trial)",
      "Up to 5 minutes per video"
    ],
    "capabilities": {
      "embed": false,
      "watermark": true,
      "customBranding": false,
      "whiteLabel": false,
      "apiAccess": false,
      "priorityProcessing": false
    }
  },
  {
    "id": "shopify_professional",
    "title": "Professional",
    "subtitle": "Embed 3D models on your storefront",
    "priceUsd": 29,
    "priceSuffix": "/month",
    "monthlyCaptureLimit": 5,
    "overageEnabled": false,
    "features": [
      "5 captures included per month",
      "Up to 15 minutes per video",
      "Place on unlimited stores",
      "PLY original file download"
    ],
    "capabilities": {
      "embed": true,
      "watermark": false,
      "customBranding": false,
      "whiteLabel": false,
      "apiAccess": false,
      "priorityProcessing": false
    }
  },
  {
    "id": "shopify_studio",
    "title": "Studio",
    "subtitle": "Scale 3D across your catalog",
    "priceUsd": 79,
    "priceSuffix": "/month",
    "monthlyCaptureLimit": 15,
    "overageEnabled": false,
    "recommended": true,
    "features": [
      "15 captures included per month",
      "Up to 15 minutes per video",
      "Everything in Professional"
    ],
    "capabilities": {
      "embed": true,
      "watermark": false,
      "customBranding": true,
      "whiteLabel": false,
      "apiAccess": false,
      "priorityProcessing": true
    }
  },
  {
    "id": "shopify_agency",
    "title": "Agency",
    "subtitle": "High-volume catalog workflows",
    "priceUsd": 149,
    "priceSuffix": "/month",
    "monthlyCaptureLimit": 35,
    "overageEnabled": false,
    "features": [
      "35 captures included per month",
      "Up to 15 minutes per video",
      "Everything in Professional",
      "Custom viewer branding"
    ],
    "capabilities": {
      "embed": true,
      "watermark": false,
      "customBranding": true,
      "whiteLabel": true,
      "apiAccess": true,
      "priorityProcessing": true
    }
  }
];

